import React from 'react';
import { withRouter } from 'react-router';
import './css/index.scss';
import { Scrollbars } from 'react-custom-scrollbars';
import RightArea from './right';
import LeftArea from './left';

class EmergencyPersonnel extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillUnmount() {
    const { setEmergencyBuildingId } = this.props;
    setEmergencyBuildingId(null);
  }

  render() {
    const { emergencyBuildingId } = this.props;

    return (
      <Scrollbars className="styleScroll ep-scroll">
        <div className="ep-container">
          <div className="ep-container__left">
            <LeftArea emergencyBuildingId={emergencyBuildingId} />
          </div>
          <div className="ep-container__right">
            <RightArea emergencyBuildingId={emergencyBuildingId} />
          </div>
        </div>
      </Scrollbars>
    );
  }
}

export default withRouter(EmergencyPersonnel);
